var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Prop, Component, Watch } from 'vue-property-decorator';
import AddDialog from './AddDialog';
var CategoryTable = (function (_super) {
    __extends(CategoryTable, _super);
    function CategoryTable() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.height = document.documentElement.clientHeight - 206;
        _this.Columns = [];
        return _this;
    }
    CategoryTable.prototype.dataWatch = function (val, oldVal) {
        if (val && val.length) {
            this.$refs.table.bodyWrapper.scrollTop = 0;
        }
    };
    CategoryTable.prototype.created = function () {
        this.Columns = [
            { prop: 'goods_type_name', 'min-width': 200, label: '类别名称' },
            { prop: 'goods_type_code', 'min-width': 120, label: '编码' },
            { prop: 'sort', 'min-width': 80, label: '排序' },
            { prop: 'parent_name', 'min-width': 120, label: '上级类别' },
        ];
    };
    CategoryTable.prototype.selectionChange = function (rows) {
        this.$emit('setSelectRows', rows);
    };
    CategoryTable.prototype.edit = function (row) {
        var _this = this;
        var instance = this.$dialog(AddDialog, {
            data: {
                category: row
            }
        }, {
            title: "编辑类别",
            width: 600,
            height: 420
        }).instance;
        instance.$on("freshCategory", function () {
            _this.$emit('search');
            _this.$emit('fresh-tree');
        });
    };
    __decorate([
        Prop({
            type: Array,
            default: []
        })
    ], CategoryTable.prototype, "data", void 0);
    __decorate([
        Watch("data")
    ], CategoryTable.prototype, "dataWatch", null);
    CategoryTable = __decorate([
        Component
    ], CategoryTable);
    return CategoryTable;
}(Vue));
export default CategoryTable;
